import { useTheme } from "@mui/material/styles";

// Colores del dashboard. Las series son los slots 1 (azul) y 2 (naranja) de la paleta categórica validada (claro y oscuro);
// la cartera por antigüedad es una rampa de un solo tono (azul) que se oscurece con la antigüedad en claro y se aclara en oscuro.
const CLARO = {
  facturado: "#2a78d6",
  cobrado: "#eb6834",
  rampa: ["#86b6ef", "#5598e7", "#2a78d6", "#1c5cab", "#104281"],
  rejilla: "#e1e0d9",
  eje: "#c3c2b7",
  tinta: "#898781",
  buenoTexto: "#006300",
  malo: "#d03b3b",
};
const OSCURO = {
  facturado: "#3987e5",
  cobrado: "#d95926",
  rampa: ["#184f95", "#1c5cab", "#256abf", "#2a78d6", "#3987e5"],
  rejilla: "#2c2c2a",
  eje: "#383835",
  tinta: "#898781",
  buenoTexto: "#0ca30c",
  malo: "#ec835a",
};

export const useColoresGrafico = () => {
  const theme = useTheme();
  return theme.palette.mode === "dark" ? OSCURO : CLARO;
};
